<div
  class="w-full rounded-[12px] overflow-hidden bg-G100 p-[32px] grid gap-4 animate-pulse"
>
  <div class="flex gap-3 items-center">
    <div
      class="w-[48px] h-[48px] bg-G300 rounded-full border-4 border-G100"
    ></div>
    <div class="grid gap-2">
      <div class="w-[194px] h-[14px] bg-G300 rounded-full"></div>
      <div class="w-[128px] h-[12px] bg-G300 rounded-full"></div>
    </div>
  </div>
  <div class="grid gap-2">
    <div class="w-full h-[14px] md:h-[16px] bg-G200 rounded-full"></div>
    <div class="w-full h-[14px] md:h-[16px] bg-G200 rounded-full"></div>
    <div class="w-1/2 h-[14px] md:h-[16px] bg-G200 rounded-full"></div>
  </div>
  <div class="w-full h-[14px] md:h-[16px] bg-G200 rounded-full"></div>
  <div class="w-full h-[14px] md:h-[16px] bg-G200 rounded-full"></div>
</div>
